import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { browserHistory } from 'react-router';
import { SegmentedControl } from 'segmented-control';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SecureShow from '../component/SecureShow';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import ExplanationsList from './ExplanationsList';
import QuestionsList from './QuestionList';
import { AppProperties } from '../common/function';
import CustomSegmentedControl from '../lib/components/CustomSegementedControl.js';
import ReactTooltip from 'react-tooltip';

let subcategory = {
  subcategory_name: '',
  subcategory_id: ''
};

export default class  SubCategoryDetails extends Component {
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  constructor(props) {
    super(props);
    this.state = {
      subCategories: [],

      temp_subcategory: subcategory,
      temp_id: '',
      addMode: true,
      subCategoryDiv: true,
      questionsDiv: false,
      explanationDiv: false,
      subject_id: this.props.location.query.subject_id,
      topic_id: this.props.location.query.topic_id,
      subject_name: this.props.location.query.subject_name,
      topic_name: this.props.location.query.topic_name,
      category_name: this.props.location.query.category_name,
      category_id: this.props.location.query.category_id,
      subcategory_name: this.props.location.query.subcategory_name,
      subcategory_id: this.props.location.query.subcategory_id,
      loading: false,
      questions_loading: false,
      mode: 0, // 0 - Questions, 1 - Explanations
      number_of_question: 0,
      readOnly:this.props.location.query.archive_mode === 'true',
      archive_id:parseInt(this.props.location.query.archive_id,10),
      archive_mode:this.props.location.query.archive_mode,
      subCategoryExplanationCount: 0
    };

    this.deleteSubCategory = this.deleteSubCategory.bind(this);

    // this.prepareAdd = this.prepareAdd.bind(this);
  }

  componentWillUpdate() {
    console.debug('componentWillUpdate');
   // this.addBreadCrumbs();
  }
 
  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
      {
        name: 'All Subjects',
        type: '',
        onclickPath: 'subjects'+
        '?archive_mode='+
        this.state.archive_mode+
        '&archive_id='+
        this.state.archive_id
      },
      {
        name: this.state.subject_name,
        type: 'Subjects',
        onclickPath:
          'topics?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      },
      {
        name: this.state.topic_name,
        type: 'Topics',
        onclickPath:
          'category?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name +
          '&topic_id=' +
          this.state.topic_id +
          '&topic_name=' +
          this.state.topic_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      },
      {
        //topic_id=1&subject_id=6&category_id=1&subject_name=Froyo&topic_name=XBOX&category_name=Motrola
        name: this.state.category_name,
        type: 'Categories',
        onclickPath:
          'subCategory?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name +
          '&topic_id=' +
          this.state.topic_id +
          '&topic_name=' +
          this.state.topic_name +
          '&category_id=' +
          this.state.category_id +
          '&category_name=' +
          this.state.category_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      },
      {
        name: this.state.subcategory_name,
        type: 'Subcategories',
        onclickPath:
          'SubCategoryDetails?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name +
          '&topic_id=' +
          this.state.topic_id +
          '&topic_name=' +
          this.state.topic_name +
          '&category_id=' +
          this.state.category_id +
          '&category_name=' +
          this.state.category_name +
          '&subcategory_id=' +
          this.state.subcategory_id +
          '&subcategory_name=' +
          this.state.subcategory_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      }
    ]);
  };

  
  createSelectItems() {
    let items = [];
    for (let i = 1; i <= 10; i++) {
      items.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return items;
  }
  onDropdownSelected(e) {
    //    alert("THE Dropdown Selected VAL : ", e.target.value);
    console.debug('THE Dropdown Selected VAL : ', e.target.value);
    let tempSubCat = this.state.temp_subcategory;
    tempSubCat.weight = e.target.value;
    this.setState({ temp_subcategory: tempSubCat });
  }
  componentDidMount() {
    this.addBreadCrumbs();

  }

  componentWillUnmount() {
    this.removeBreadCrumbs();
  }
  componentDidUpdate() {
    // refresh the page if url changed
    let paramsSubjectId = this.props.location.query.subject_id
    let paramsTopicId = this.props.location.query.topic_id
    let paramscategoryId = this.props.location.query.category_id
    let paramsSubCategoryId = this.props.location.query.subcategory_id

    if (this.state.subject_id !== paramsSubjectId  || 
      this.state.topic_id !== paramsTopicId ||
      this.state.category_id !== paramscategoryId ||
      this.state.subcategory_id !== paramsSubCategoryId
      ) {
        this.setState({
        subject_id : this.props.location.query.subject_id,
        topic_id : this.props.location.query.topic_id,
        subject_name : this.props.location.query.subject_name,
        topic_name : this.props.location.query.topic_name,
        category_name : this.props.location.query.category_name,
        category_id : this.props.location.query.category_id,
        subcategory_name : this.props.location.query.subcategory_name,
        subcategory_id : this.props.location.query.subcategory_id,
      })
      }
      this.addBreadCrumbs();
  }



  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };

  deleteSubCategory(id) {
    console.debug(
      'Deleting subcategory i:' +
        id +
        ' id: ' +
        this.state.subCategories[id].subcategory_id
    );
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    var cat_id = parseInt(this.state.category_id, 10);
    let payload = {
      subcategory_id: this.state.subCategories[id].subcategory_id,
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id
    };
    if(this.state.archive_mode === 'true'){
      payload['archive_id'] = this.state.archive_id;
      payload['archive_mode'] = true;
    }
    this.setState({ loading: true });

    ApiRequestService({
      method: 'post',
      url: '/deleteSubCategory',
      data: payload
    }).then(res => {
      this.setState({ loading: false });

      console.debug(res);
      //window.localtion.reload();
      this.state.subCategories.splice(id, 1);
      console.debug('Spliced Array', this.state.subCategories);
      this.setState({
        subCategories: this.state.subCategories
      });
    });
  }

  numberOfQuestion = (number) =>{
    this.setState({
      number_of_question: number
    });
  }

  tabOnChange(e) {
    console.debug(e);
    if (e === 'Questions') {
      this.setState({
        subCategoryDiv: false,
        questionsDiv: true,
        explanationDiv: false,
        mode: 0
      });
    } else if (e === 'Explanation') {
      this.setState({
        subCategoryDiv: false,
        questionsDiv: false,
        explanationDiv: true,
        mode: 1
      });
    }
  }

  subjPage() {
    browserHistory.push(this.baseFolder + 'subjects');
  }
  topcPage = () => {
    browserHistory.push(
      this.baseFolder +
        'topics?subject_id=' +
        this.state.subject_id +
        '&subject_name=' +
        this.state.subject_name
    );
  };
  catgPage = () => {
    browserHistory.push(
      this.baseFolder +
        'category?subject_id=' +
        this.state.subject_id +
        '&subject_name=' +
        this.state.subject_name +
        '&topic_id=' +
        this.state.topic_id +
        '&topic_name=' +
        this.state.topic_name
    );
  };
  catDetailsPage = () => {
    browserHistory.push(
      this.baseFolder +
        'subcategory?subject_id=' +
        this.state.subject_id +
        '&subject_name=' +
        this.state.subject_name +
        '&topic_id=' +
        this.state.topic_id +
        '&topic_name=' +
        this.state.topic_name +
        '&category_id=' +
        this.state.category_id +
        '&category_name=' +
        this.state.category_name
    );
  };
  delete = id => {
    confirmAlert({
      title: 'Are you sure want to delete this SubCategory?',
      message: 'Press Confirm to submit',

      cancelLabel: 'Confirm',
      confirmLabel: 'Cancel',
      onCancel: () => this.deleteSubCategory(id)
    });
  };


  render() {
    return (
      (this.state.loading)?
         <LoadingSpinner loading={this.state.loading} style={{width:"100px"}} />
      :
      <SecureShow targetRole={1}>

        <div style={styles.bodyBGStyle} className="bodyContainer"  style={{ marginTop:"120px"}}>
          {/* <div style={styles.subcategoryDetailsSegemntStyle}  className="SegmentedControlContainer">
            <SegmentedControl className="segmentedControl"
              name="oneDisabled"
              options={[
                { label: 'Questions', value: 'Questions', default: true },
                { label: 'Explanations', value: 'Explanation' }
              ]}
              setValue={newValue => this.tabOnChange(newValue)}
              style={styles.SegmentedControl} //
            />
          </div> */}

          <div style={{
            ...styles.catTitle,
            opacity: this.state.questions_loading ? 0 : 1,
          }} className="subCategoryDivStyle">
            SubCategory Details - {this.state.subcategory_name}
            <div style={styles.catTitleRight}># of questions - {this.state.number_of_question}</div>
          </div>

            <div style={{
                  width:'400px',
                  marginTop:'16px',
                  marginLeft:'2rem',
                  opacity: this.state.questions_loading ? 0 : 1,
                }}>
                <CustomSegmentedControl
                    options={[
                      { label: 'Questions', value: 'Questions', default: true },
                      { label: (
                        <div>
                          <ReactTooltip  effect='solid' id='explanation' type='light' className='tool-tip'>
                            <span>
                            {this.state.subCategoryExplanationCount === 0 ? "No explanations for this subcategory" :
                              `View explanations for this subcategory`
                            }
                            </span>
                          </ReactTooltip>
                          <div data-tip data-for='explanation'>Explanations ({this.state.subCategoryExplanationCount})</div>
                      </div>
                      ), value: 'Explanation' }
                    ]}
                    setValue={(newValue )=> this.tabOnChange(newValue)}
                    style={styles.categorySegmentedControl}
                  />
              </div>

          {this.state.mode === 0 ? (
            <QuestionsList
              subject_id={this.state.subject_id}
              topic_id={this.state.topic_id}
              category_id={this.state.category_id}
              subcategory_id={this.state.subcategory_id}
              readOnly={this.state.readOnly}
              updateLoading={(loading) => {
                this.setState({questions_loading: loading});
              }}
              archive_id={this.state.archive_id}
              archive_mode={this.state.archive_mode}
              number_of_question={this.numberOfQuestion}
              location={this.props.location}
              updateTotalCount={(updatedCount) => {
                this.setState({
                  subCategoryExplanationCount: updatedCount,
                })
              }}
            />
          ) : (
            <div id="subCategoryDetails">
              <ExplanationsList
                subject_id={this.state.subject_id}
                topic_id={this.state.topic_id}
                category_id={this.state.category_id}
                subcategory_id={this.state.subcategory_id}
                loading={this.state.loading}
                readOnly={this.state.readOnly}
                archive_id={this.state.archive_id}
                archive_mode={this.state.archive_mode}
                updateTotalCount={(updatedCount) => {
                  this.setState({
                    subCategoryExplanationCount: updatedCount,
                  })
                }}
              />
            </div>
          )}
        </div>
      </SecureShow>
    );
  }
}
